import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";
import { BrandModule } from "../brand/brand.module";

import { ActivateComponent } from './activate.component';
// import { RestoreFormComponent } from "./form/component";
import { ActivateService } from "./activate.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        BrandModule
    ],
    declarations: [
        ActivateComponent,
        // RestoreFormComponent
    ],
    providers: [
        ActivateService
    ]
})
export class ActivateModule { }


// WEBPACK FOOTER //
// ./src/app/public/activate/activate.module.ts